/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WhatsAppConnectCompletionRequest
 */
export interface WhatsAppConnectCompletionRequest {
  /**
   *
   * @type {string}
   * @memberof WhatsAppConnectCompletionRequest
   */
  challengeToken: string;
}

/**
 * Check if a given object implements the WhatsAppConnectCompletionRequest interface.
 */
export function instanceOfWhatsAppConnectCompletionRequest(
  value: object
): value is WhatsAppConnectCompletionRequest {
  if (!("challengeToken" in value) || value["challengeToken"] === undefined)
    return false;
  return true;
}

export function WhatsAppConnectCompletionRequestFromJSON(
  json: any
): WhatsAppConnectCompletionRequest {
  return WhatsAppConnectCompletionRequestFromJSONTyped(json, false);
}

export function WhatsAppConnectCompletionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WhatsAppConnectCompletionRequest {
  if (json == null) {
    return json;
  }
  return {
    challengeToken: json["challenge_token"],
  };
}

export function WhatsAppConnectCompletionRequestToJSON(
  json: any
): WhatsAppConnectCompletionRequest {
  return WhatsAppConnectCompletionRequestToJSONTyped(json, false);
}

export function WhatsAppConnectCompletionRequestToJSONTyped(
  value?: WhatsAppConnectCompletionRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    challenge_token: value["challengeToken"],
  };
}
